const DEVICE_FINGERPRINT_COOKIE = 'device-fingerprint';
const shippingAddressTypeCookie = 'shippingAddressType';
const GOOGLE_ANALYTIC_COOKIE = '_ga';
const TYPESENSE_COOKIE = '_TYPESENSE';
const UTM_SOURCE_COOKIE = 'utm_source';
const VUESTOREFRONT_COOKIE = {
  COMMERCETOOLS_TOKEN: 'vsf-commercetools-token',
  COUNTRY: 'vsf-country',
  LOCALE: 'vsf-locale',
  CURRENCY: 'vsf-currency',
  STORE: 'vsf-store',
};
const COOKIE_SEPARATOR = '; ';
const CUSTOMER_ID_COOKIE = 'customer_id';
export { DEVICE_FINGERPRINT_COOKIE };
export { shippingAddressTypeCookie };
export { GOOGLE_ANALYTIC_COOKIE };
export { TYPESENSE_COOKIE };
export { VUESTOREFRONT_COOKIE };
export { COOKIE_SEPARATOR };
export { UTM_SOURCE_COOKIE };
export { CUSTOMER_ID_COOKIE };
